import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { DOCUMENTOS_OBJETO_E_PE } from '../../shared/certidoesPositivasSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';
import { DEFICIENCIA_OPCOES, DEFICIENCIA_NAO_POSSUI_ID, SEXO_OPCOES } from '../../shared/catalogosPessoaFisica';

const pedidoReativacaoConfig = {
  id: 'pedido_reativacao',
  nome: 'Reativação de Inscrição',
  categoria: 'inscricao',
  descricao: 'Solicitação de reativação de inscrição na OAB/MS',
  icon: 'FaSyncAlt',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento de reativação preenchido e assinado digitalmente', required: true },
      { id: 'declaracaoAutenticidade', tipoDocumentoProcesso: 492, name: 'Declaração de Autenticidade', description: 'Declaração de autenticidade dos documentos apresentados, preenchida e assinada', required: true },
      { id: 'declaracaoIdoneidade', tipoDocumentoProcesso: 318, name: 'Declaração de Idoneidade', description: 'Declaração de idoneidade (modelo padrão)', required: true },
      { id: 'certidaoEstadualCivel', tipoDocumentoProcesso: 514, name: 'Certidão Estadual 1º Grau Cível de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualCriminal', tipoDocumentoProcesso: 515, name: 'Certidão Estadual 1º Grau Criminal de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualCrimeMilitar', tipoDocumentoProcesso: 516, name: 'Certidão Estadual 1º Grau Crime Militar de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoFederalCivel', tipoDocumentoProcesso: 520, name: 'Certidão Federal de 1º e 2º Grau Cível do TRF3 – Abrangência Regional', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoFederalCriminal', tipoDocumentoProcesso: 519, name: 'Certidão Federal de 1º e 2º Grau Criminal do TRF3 – Abrangência Regional', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoJusticaFederalMilitar', tipoDocumentoProcesso: 503, name: 'Certidão Justiça Federal Militar (STM)', description: 'Expedida pelo Superior Tribunal Militar (STM). Obrigatória para ambos os sexos.', required: true },
      { id: 'comprovanteResidencia', tipoDocumentoProcesso: 509, name: 'Comprovante de Residência', description: 'Serão aceitos somente contas de Água ou Luz', required: true },
      { id: 'cpf', tipoDocumentoProcesso: 510, name: 'CPF', description: 'Documento do CPF', required: true },
      { id: 'tituloEleitor', tipoDocumentoProcesso: 511, name: 'Título de Eleitor', description: 'Título de Eleitor', required: true }
    ],

    conditional: [
      ...DOCUMENTOS_OBJETO_E_PE,
      {
        id: 'publicacaoExoneracao', tipoDocumentoProcesso: 562,
        name: 'Publicação da Exoneração/Aposentadoria',
        description: 'Obrigatória quando o motivo do cancelamento for cargo incompatível com a advocacia',
        conditional: true,
        required: true,
        dependsOn: { field: 'motivoCancelamento', value: 'CARGO_INCOMPATIVEL' }
      },
      {
        id: 'declaracaoResidencia', tipoDocumentoProcesso: 493,
        name: 'Declaração de Residência',
        description: 'Obrigatória quando o endereço residencial informado não estiver em seu nome',
        conditional: true,
        required: true,
        dependsOn: { field: 'enderecoEmSeuNome', value: 'NAO' }
      },
      {
        id: 'atestadoFuncional', tipoDocumentoProcesso: 324,
        name: 'Atestado Funcional',
        description: 'Atestado funcional detalhando atribuições e atividades do cargo (obrigatório para servidores públicos e instituições financeiras)',
        conditional: true,
        required: true,
        dependsOn: { field: 'exerceFuncaoPublica', value: 'SIM' }
      },
      {
        id: 'cid', tipoDocumentoProcesso: 456,
        name: 'Laudo Médico (CID)',
        description: 'Laudo médico atualizado com CID (obrigatório para PCD)',
        conditional: true,
        required: true,
        dependsOn: { field: 'possuiDeficiencia', notValue: DEFICIENCIA_NAO_POSSUI_ID }
      },
      {
        id: 'reservista', tipoDocumentoProcesso: 84,
        name: 'Certificado de Reservista ou Dispensa',
        description: 'Certificado de reservista ou documento de dispensa (obrigatório para homens com menos de 45 anos). Conforme Art. 5º da Lei nº 4.375/1964, maiores de 45 anos são desobrigados.',
        conditional: true,
        required: true,
      },
      {
        id: 'certidaoCasamento', tipoDocumentoProcesso: 508,
        name: 'Certidão de Casamento',
        description: 'Certidão de casamento atualizada (obrigatória quando houver alteração de nome por casamento)',
        conditional: true,
        required: true,
        dependsOn: [{ field: 'estadoCivil', value: 'Casado' }, { field: 'nomeDifereIdentificacao', value: 'SIM' }]
      },
      {
        id: 'rgOuCin', tipoDocumentoProcesso: 506,
        name: 'RG / CIN',
        description: 'Registro Geral ou Carteira de Identidade Nacional (CIN)',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoDocumentoIdentificacao', value: 'RG_CIN' }
      },
      {
        id: 'cnh', tipoDocumentoProcesso: 507,
        name: 'CNH',
        description: 'Carteira Nacional de Habilitação. Serão aceitas somente emissões a partir de 1º de junho de 2022',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoDocumentoIdentificacao', value: 'CNH' }
      },
      {
        id: 'certidaoEstadualForaEstado', tipoDocumentoProcesso: 526,
        name: 'Certidão Estadual de 1º Grau Cível, Criminal e Crime Militar – Estado de Origem',
        description: 'Juntar Certidão Cível, Criminal e Crime Militar em arquivo único PDF',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoReativacao', value: 'SUPLEMENTAR' }
      },
      {
        id: 'certidaoFederalCivelOrigem', tipoDocumentoProcesso: 527,
        name: 'Certidão Federal de 1º Grau Cível - Estado de Origem',
        description: 'Certidão federal cível da região de origem',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoReativacao', value: 'SUPLEMENTAR' }
      },
      {
        id: 'certidaoFederalCriminalOrigem', tipoDocumentoProcesso: 528,
        name: 'Certidão Federal de 1º Grau Criminal - Estado de Origem',
        description: 'Certidão federal criminal da região de origem',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoReativacao', value: 'SUPLEMENTAR' }
      },
      {
        id: 'certidaoInteiroTeor', tipoDocumentoProcesso: 558,
        name: 'Certidão de Inteiro Teor – Seccional de Origem',
        description: 'Certidão de inteiro teor emitida pela Seccional de origem',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoReativacao', value: 'SUPLEMENTAR' }
      }
    ],
  },

  paymentConfig: {
    dynamicAmount: true,
    dynamicField: 'tipoReativacao',
    options: {
      ORIGINARIA: { name: 'Reativação da Inscrição Originária', amount: 298.00 },
      SUPLEMENTAR: { name: 'Reativação da Inscrição Suplementar', amount: 270.00 }
    }
  },

  protocoloConfig: {
    modeloRequerimento: {
      field: 'tipoReativacao',
      map: { ORIGINARIA: '190', SUPLEMENTAR: '196' }
    },
    tiposAssunto: '267',
    tipoPedido: {
      field: 'tipoReativacao',
      map: { ORIGINARIA: '238', SUPLEMENTAR: '246' }
    }
  },

  // Confirmado ao vivo (190 e 196 têm o mesmo conjunto de campos: só
  // Nome/CPFCNPJ/EmailResidencial + endereço, sem RG/título eleitor/etc).
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'cpf', campoNome: 'CPFCNPJ' }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
  ),

  tituloConfig: {
    tipoLancamentoId: 91,
    enderecoOrigem: 'residencial'
  },

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'date', name: 'dataNascimento', label: 'Data de Nascimento', required: true },
            { type: 'radio', name: 'sexo', label: 'Sexo', required: true, options: SEXO_OPCOES }
          ]
        },
        {
          title: 'Tipo de Reativação',
          fields: [
            {
              type: 'radio',
              name: 'tipoReativacao',
              label: 'Tipo de Reativação',
              required: true,
              options: [
                { value: 'ORIGINARIA', label: 'Reativação para Inscrição Originária' },
                { value: 'SUPLEMENTAR', label: 'Reativação para Inscrição Suplementar' }
              ],
              defaultValue: 'ORIGINARIA'
            },
            {
              type: 'radio',
              name: 'motivoCancelamento',
              label: 'O motivo do cancelamento foi devido a:',
              required: true,
              options: [
                { value: 'CARGO_INCOMPATIVEL', label: 'Cargo incompatível com a advocacia' },
                { value: 'NAO_EXERCIA', label: 'Não estava exercendo a profissão / Não estava atuando no Estado' }
              ]
            }
          ]
        },
        {
          title: 'Documentos pessoais e eleitorais',
          fields: [
            { type: 'text', name: 'documentoIdentidade', label: 'Documento de Identidade (RG/CIN)', placeholder: 'Nº do RG ou CIN', required: true },
            { type: 'text', name: 'orgaoEmissor', label: 'Órgão Expedidor', placeholder: 'Ex: SSP, DETRAN', required: true },
            { type: 'date', name: 'dataEmissao', label: 'Data Emissão', required: true },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true },
            { type: 'text', name: 'tituloEleitor', label: 'Título de Eleitor', placeholder: 'Nº do título', required: true },
            { type: 'text', name: 'zonaEleitoral', label: 'Zona do Título', placeholder: 'Zona', required: true },
            { type: 'text', name: 'secaoEleitoral', label: 'Seção do Título', placeholder: 'Seção', required: true },
            { type: 'text', name: 'municipioTitulo', label: 'Município do Título', placeholder: 'Cidade do título', required: true },
            {
              type: 'radio',
              name: 'tipoDocumentoIdentificacao',
              label: 'Qual documento de identificação você vai enviar?',
              required: true,
              options: [
                { value: 'RG_CIN', label: 'RG / CIN (Carteira de Identidade Nacional)' },
                { value: 'CNH', label: 'CNH (Carteira Nacional de Habilitação)' }
              ],
              defaultValue: 'RG_CIN'
            },
            {
              type: 'dataEmissaoCNH',
              name: 'dataEmissaoCNH',
              label: 'Data de Emissão da CNH',
              required: true,
              showWhen: { field: 'tipoDocumentoIdentificacao', value: 'CNH' }
            }
          ]
        },
        {
          title: 'Declarações pessoais',
          fields: [
            {
              type: 'select',
              name: 'possuiDeficiencia',
              label: 'Deficiência',
              required: true,
              options: DEFICIENCIA_OPCOES,
              defaultValue: DEFICIENCIA_NAO_POSSUI_ID
            },
            {
              type: 'radio',
              name: 'exerceFuncaoPublica',
              label: 'Exerce função/emprego público?',
              required: true,
              options: [{ value: 'SIM', label: 'Sim' }, { value: 'NAO', label: 'Não' }],
              defaultValue: 'NAO'
            },
            {
              type: 'text',
              name: 'orgaoFuncaoPublica',
              label: 'Órgão / Instituição',
              required: true,
              placeholder: 'Ex: Tribunal de Justiça, Ministério Público, etc.',
              showWhen: { field: 'exerceFuncaoPublica', value: 'SIM' }
            },
            {
              type: 'text',
              name: 'cargoFuncaoPublica',
              label: 'Cargo / Função',
              required: true,
              placeholder: 'Ex: Juiz, Promotor, Analista, etc.',
              showWhen: { field: 'exerceFuncaoPublica', value: 'SIM' }
            },
            {
              type: 'radio',
              name: 'nomeDifereIdentificacao',
              label: 'O nome que consta no seu documento de identificação é diferente do seu nome atual (nome de solteiro(a))?',
              showWhen: { field: 'estadoCivil', value: 'Casado' },
              required: true,
              options: [
                { value: 'SIM', label: 'Sim, meu nome atual é diferente do nome no documento' },
                { value: 'NAO', label: 'Não, meu nome é o mesmo' }
              ],
              defaultValue: 'NAO'
            }
          ]
        },
        {
          title: 'Estado Civil',
          fields: [
            {
              type: 'select',
              name: 'estadoCivil',
              label: 'Estado Civil',
              required: true,
              options: [
                { value: 'Solteiro', label: 'Solteiro(a)' },
                { value: 'Casado', label: 'Casado(a)' },
                { value: 'Divorciado', label: 'Divorciado(a)' },
                { value: 'Viuvo', label: 'Viúvo(a)' },
                { value: 'UniaoEstavel', label: 'União Estável' }
              ]
            }
          ]
        },
        {
          title: 'Dados da Seccional de Origem (para Reativação Suplementar)',
          fields: [
            {
              type: 'text',
              name: 'seccionalOrigem',
              label: 'Seccional de Origem',
              required: true,
              placeholder: 'Ex: OAB/SP, OAB/RJ',
              showWhen: { field: 'tipoReativacao', value: 'SUPLEMENTAR' }
            },
            {
              type: 'text',
              name: 'numeroInscricaoOrigem',
              label: 'Número de Inscrição na Seccional de Origem',
              required: true,
              placeholder: 'Nº da inscrição',
              showWhen: { field: 'tipoReativacao', value: 'SUPLEMENTAR' }
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    termosStep(['validadeCertidoes', 'assinaturaDigitalComIdoneidade'], { certidoesPositivas: true })
  ]
};

export default pedidoReativacaoConfig;